import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { textReveal } from './text-reveal';
gsap.registerPlugin(ScrollTrigger);

function animateListingPage() {
  const cards = document.querySelectorAll('.page-view-listing .image-card');

  if (!cards.length > 0) return;

  ScrollTrigger.batch(cards, {
    onEnter: (batch) => animateBatch(batch),
  });
}

function animateRelatedContent() {
  const relatedContent = document.querySelector('.related-content');

  if (!relatedContent) return;

  const title = relatedContent.querySelector('.related-content__heading');
  const cards = relatedContent.querySelectorAll('.related-content__items .image-card');

  textReveal(title, title, undefined, undefined, 0);

  if (cards.length > 0) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: title,
        start: 'top 85%',
        scrub: false,
        toggleActions: 'play none none reverse',
      },
    });

    tl.fromTo(
      cards,
      {
        y: 50,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.4,
        stagger: 0.2,
        ease: 'none',
      },
    );
  }
}

function animateParagraphCards() {
  const paragraphCards = document.querySelectorAll('.paragraph--type--cards');

  if (!paragraphCards.length > 0) return;

  paragraphCards.forEach((paragraph) => {
    const title = paragraph.querySelector('.paragraph__heading');
    const subheading = paragraph.querySelector('.paragraph__sub-heading');
    const cards = paragraph.querySelectorAll('.cards__list .image-card');

    textReveal(paragraph, title, subheading, undefined, 0);

    if (cards.length > 0) {
      ScrollTrigger.batch(cards, {
        onEnter: (batch) => animateBatch(batch),
      });
    }
  });
}

function animateBatch(batch) {
  gsap.fromTo(
    batch,
    {
      y: 50,
      opacity: 0,
    },
    {
      opacity: 1,
      y: 0,
      stagger: 0.15,
      duration: 0.4,
      ease: 'none',
    },
  );
}

window.addEventListener('DOMContentLoaded', () => {
  animateListingPage();
  animateRelatedContent();
  animateParagraphCards();
});
